import React, { Component } from "react";
import compose from "recompose/compose";
import { withStyles } from "@material-ui/core/styles";
import EventCard from "./detailscards/EventCard";
import EventInfoCard from "./detailscards/EventInfoCard";
import EventDescriptionCard from "./detailscards/EventDescriptionCard";
import EventVenue from "./detailscards/EventVenue";

import EventOrganizer from "./EventOrganizer";
import EventSponsers from "./EventSponsers";
import { withRouter } from "react-router-dom";
const styles = (theme) => ({
  details: {
    flex: "0.8",
    // border: "2px solid green",
  },
});

class Details extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { classes, data } = this.props;
    return (
      <div className={classes.details}>
       {data?.challengeType=="TEAM_RELAY" &&<EventDescriptionCard data={data}/>}
        <EventCard data={data} />
        <EventInfoCard data={data} />
      
        <EventOrganizer data={data} />
        {data?.eventSponsors?.length > 0 && <EventSponsers data={data} />}
      </div>
    );
  }
}

export default compose(withStyles(styles, { withTheme: true }),withRouter)(Details);
